import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import ManagedInput from 'components/form/managed_input';

export function DateReference({
  dateReference,
  playbook,
  setDateReference,
  stage,
  task 
}) {
  const dateFields = useMemo(() => playbook.allFieldsByStage[stage].filter(field => field.isDate), [stage]);

  React.useEffect(() => {
    setDateReference(task?.dateReference || dateFields[0].name);
  }, []);

  return (
    <ManagedInput
      className="date-reference form-control"
      name="dateReference"
      type="select"
      value={dateReference}
      onValueChange={setDateReference}
    >
      {dateFields.map(field => (
        <option key={field.name} value={field.name}>
          {field.label}
        </option>
      ))}
    </ManagedInput>
  );
}

DateReference.propTypes = {
  dateReference: PropTypes.string,
  playbook: PropTypes.shape({
    allFieldsByStage: PropTypes.objectOf(
      PropTypes.arrayOf(PropTypes.object)
    ).isRequired,
  }).isRequired,
  setDateReference: PropTypes.func.isRequired,
  stage: PropTypes.string.isRequired,
  task: PropTypes.object
};

const mapStateToProps = state => ({
  stage: state.stage.key,
});

export default connect(mapStateToProps)(DateReference);
